// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

function Select$1(Props) {
  var disabledOpt = Props.disabled;
  var options = Props.options;
  var value = Props.value;
  var setValue = Props.setValue;
  var toKey = Props.toKey;
  var fromKey = Props.fromKey;
  var className = Props.className;
  var classes = Props.classes;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var screenSize = ScreenAtom.use(undefined);
  var tmp = {
    native: screenSize >= 4,
    value: Curry._1(toKey, value),
    onChange: (function (e) {
        var v = e.target.value;
        return Curry._1(setValue, Curry._1(fromKey, v));
      }),
    variant: "standard",
    children: screenSize >= 4 ? Belt_Array.map(options, (function (param) {
              var v = param[0];
              return React.createElement("option", {
                          key: Curry._1(toKey, v),
                          value: Curry._1(toKey, v)
                        }, param[1]);
            })) : Belt_Array.map(options, (function (param) {
              var v = param[0];
              return React.createElement(MenuItem, {
                          value: Curry._1(toKey, v),
                          children: param[1],
                          key: Curry._1(toKey, v)
                        });
            }))
  };
  if (classes !== undefined) {
    tmp.classes = Caml_option.valFromOption(classes);
  }
  if (className !== undefined) {
    tmp.className = className;
  }
  return React.createElement(FormControl, {
              disabled: disabled,
              children: React.createElement(Select, tmp)
            });
}

var make = Select$1;

export {
  make ,
  
}
/* react Not a pure module */
